import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import Toggle from 'components/ReusableComponents/Toggle'
import { canadaTimeZones, UStimeZones } from 'features/ManageUserDialog'
import { useEffect } from 'react'

import styles from '../../NewHotel.module.scss'

const ImportantUsersSection = ({ formData, setFormData }) => {
  useEffect(() => {
    if (!formData.newUsers) {
      setFormData({
        ...formData,
        newUsers: [
          {
            fullName: '',
            email: '',
            phone: '',
            timeZoneName: '',
            isGeneralManager: true,
            isAccountBillable: false
          }
        ]
      })
    }
  }, [formData, setFormData])

  const handleUserChange = (index, field, value) => {
    const updatedUsers = [...formData.newUsers]
    updatedUsers[index] = {
      ...updatedUsers[index],
      [field]: value
    }
    setFormData({ ...formData, newUsers: updatedUsers })
  }

  const toggleAccountBillable = index => {
    const updatedUsers = [...formData.newUsers]
    const isBecomingAccountBillable = !updatedUsers[index].isAccountBillable

    if (isBecomingAccountBillable) {
      const filteredUsers = updatedUsers.filter(
        user => !user.isAccountBillable || user.isGeneralManager
      )
      filteredUsers[index].isAccountBillable = true
      setFormData({ ...formData, newUsers: filteredUsers })
    } else {
      updatedUsers[index].isAccountBillable = false
      updatedUsers.push({
        fullName: '',
        email: '',
        phone: '',
        timeZoneName: '',
        isGeneralManager: false,
        isAccountBillable: true
      })
      setFormData({ ...formData, newUsers: updatedUsers })
    }
  }

  return (
    <div className={styles.importantUsersSection}>
      <h4 className={styles.sectionTitle}>User Information</h4>

      {formData.newUsers.map((user, index) => (
        <div key={index} className={styles.userSection}>
          <h5 className={styles.userType}>
            {user.isGeneralManager ? 'General Manager' : 'Account Billable'}
          </h5>
          <div className={styles.formRow}>
            <TextInput
              className={styles.fullNameInput}
              label="Full name"
              value={user.fullName}
              onChange={e => handleUserChange(index, 'fullName', e.target.value)}
            />
            <TextInput
              label="Email"
              value={user.email}
              onChange={e => handleUserChange(index, 'email', e.target.value)}
            />
          </div>
          <div className={styles.formRow}>
            <TextInput
              label="Phone (optional)"
              value={user.phone}
              onChange={e => handleUserChange(index, 'phone', e.target.value)}
            />
            <Dropdown
              defaultVal="Select timezone"
              options={{ ...UStimeZones, ...canadaTimeZones }}
              isSortedAlphabetically={false}
              label="Timezone"
              value={user.timeZoneName}
              onChange={e => handleUserChange(index, 'timeZoneName', e.target.value)}
            />
          </div>

          {user.isGeneralManager && (
            <Toggle
              className={styles.GMtoggle}
              label="GM is also account billable"
              checked={user.isAccountBillable}
              handleChange={() => toggleAccountBillable(index)}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default ImportantUsersSection
